import Container from '@/components/atoms/Container'
import Icon from '@/components/atoms/Icon'
import { useNavigate } from 'react-router-dom'

export function Hero() {
	const navigate = useNavigate()

	return (
		<Container className='flex flex-col py-10 gap-10'>
			<div className='flex flex-col items-start'>
				<button
					onClick={() => navigate('/mentorias')}
					className='flex items-center justify-center font-bold text-base leading-[18px] text-white gap-2'
				>
					<Icon
						name='arrow-left'
						width='27'
						height='14'
						className='fill-white'
					/>
					<div>Voltar para todos os mentores</div>
				</button>
			</div>

			<div className='flex flex-col gap-2'>
				<h1 className='text-2xl text-white font-medium'>Créditos</h1>
				<h3 className='text-base text-white/70'>
					Acompanhe seu saldo de créditos e histórico de utilizações abaixo
				</h3>
			</div>
		</Container>
	)
}
